import React, { useEffect, useState, useMemo } from 'react';
import AcceptanceView from './AcceptanceView';
import useQueryParameters from 'hooks/useQueryParameters';
import useMagicLinkAcceptance from 'hooks/requests/magicLinkAcceptance';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import LoadingPage from 'components/LoadingPage';
import { useSelector } from 'react-redux';
import { selectTenant } from 'state/tenant';

const Acceptance: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const {
    enabledFeatures: { magicLinkVerification },
  } = useSelector(selectTenant);

  const { push } = useNavigationHelpers();
  const { magicLinkId, magicLinkOtp, vfp } = useQueryParameters();

  const [magicLinkAcceptance] = useMagicLinkAcceptance();
  const showOtp = Boolean(
    magicLinkVerification && magicLinkVerification.otpRequired,
  );
  const otp = useMemo(() => (showOtp ? magicLinkOtp : null), [
    magicLinkOtp,
    showOtp,
  ]);

  useEffect(() => {
    if (!magicLinkId || !magicLinkOtp || !vfp) {
      push('/magic_link_acceptance/error');
      return;
    }
    const magicLinkAcceptanceResult = async () => {
      try {
        await magicLinkAcceptance({
          magicLinkId,
          magicLinkOtp,
          verificationFingerprint: vfp,
        });
        setIsLoading(false);
      } catch (e) {
        push('/magic_link_acceptance/error');
      }
    };

    magicLinkAcceptanceResult();
    // Ensure we only sent this once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!magicLinkId || !magicLinkOtp || isLoading) {
    return <LoadingPage headerTitle="Loading..." />;
  } else {
    return <AcceptanceView otp={otp} />;
  }
};

export default Acceptance;
